/**
 * Remembers the rep's last dialer choices so reopening the dialer lands on the
 * setup they were already using, instead of resetting to the default channel
 * every time.
 *
 * Channel only. Caller ID is not stored here: it already persists server-side as
 * member_vobiz.fromNumber, which is the value VoBiz dials with, so a local copy
 * could only ever disagree with what actually goes out on the wire.
 *
 * Scoped per member: shared machines must not leak one rep's setup to another.
 */

const PREFIX = "sg.dialer.prefs";

const keyFor = memberId => `${PREFIX}.${memberId || "anonymous"}`;

/** localStorage throws in private mode and when the quota is full — never let that break the dialer. */
const readPrefs = memberId => {
  try {
    const raw = window.localStorage.getItem(keyFor(memberId));
    return raw ? JSON.parse(raw) || {} : {};
  } catch (e) {
    return {};
  }
};

const writePrefs = (memberId, prefs) => {
  try {
    window.localStorage.setItem(keyFor(memberId), JSON.stringify(prefs));
  } catch (e) {
    // Preference persistence is a convenience — losing it must never block a call.
  }
};

export const getPreferredChannel = memberId => readPrefs(memberId).channel || "";

export const setPreferredChannel = (memberId, channel) => {
  if (!channel) return;
  writePrefs(memberId, { ...readPrefs(memberId), channel });
};

// Caller ID is deliberately not remembered here. It already persists server-side
// (member_vobiz.fromNumber), and that same field is what VoBiz dials with, so a local
// copy could only ever disagree with what actually goes out on the wire.

